import { Periods, Rule, TollDomainDetails, Variant } from 'ctp-toll-domain';
import { namespace as createVuexClass } from 'vuex-class';

export const namespace = 'tollDomain';
export const store = createVuexClass(namespace);

export const FETCH_TOLL_DOMAIN_INFO_BY_ID = 'fetchTollDomainInfoByID';
export const FETCH_TOLL_DOMAINS = 'fetchTollDomains';
export const FETCH_TOTAL_TOLL_DOMAINS = 'fetchTotalTollDomains';
export const CREATE_RULE = 'createRule';
export const UPDATE_RULE = 'updateRule';
export const FETCH_RULE_BY_ID = 'fetchRuleByID';
export const CREATE_GEOMETRY = 'createGeometry';
export const DELETE_TOLL_DOMAIN = 'deleteTollDomain';
export const EDIT_TOLL_DOMAIN = 'editTollDomain';
export const UPDATE_DOMAINS_STATE = 'updateDomainsState';
export const USER_SELECTION_REGISTER_DOMAIN = 'userSelectionRegisterDomain';
export const USER_SELECTION_CLEAR_DOMAINS = 'userSelectionClearDomains';
export const USER_SELECTION_RESET_ACTIONS = 'userSelectionResetActions';
export const TRIGGER_DOMAIN_USER_SELECTION_ACTION = 'triggerDomainUserSelectionAction';
export const TOLL_DOMAIN_NAVIGATION = 'tollDomainNavigation';
export const UPDATE_NAVIGATION = 'updateNavigation';
export const SET_ERROR = 'setError';
export const REINIT = 'reinit';
export const TOLL_DOMAIN_IS_UNIQUE = 'tollDomainIsUnique';
export const ACTIVATE_GEOMETRY = 'activateGeometry';
export const FETCH_GEODIFF = 'fetchGeometryDiff';
export const FETCH_CURRENT_GEO = 'fetchCurrentGeometry';
export const FETCH_PERIODS = 'fetchPeriods';
export const FETCH_GEOJSON = 'fetchGeoJson';
export const FETCH_VARIANTS = 'fetchVariants';
export const FETCH_VARIANT_BY_ID = 'fetchVariantById';
export const FETCH_DEFAULT_VARIANT = 'fetchDefaultVariant';
export const CREATE_VARIANT = 'createVariant';

export interface IDomainsState {
  [view: string]: boolean;
}

export interface IDomainsStatePayload {
  stateKey: string;
  view: string;
  stateValue: boolean;
}

export interface ITollDomainsState {
  [state: string]: IDomainsState;
}

export interface INavigation {
  start: number;
  domainsPerPage: number;
  direction: 'backward' | 'forward';
  isLastDomainPage: boolean;
}

export interface IDomainsActions {
  label: string;
  enabled: boolean;
}

export interface IUserSelection {
  domains: string[];
  actions: {
    [key: string]: IDomainsActions;
  };
}

export interface INotification {
  notificationStatus: string;
  code: number;
}

export interface TollDomainState {
  tollDomainsState: ITollDomainsState;
  domains: Array<any>;
  domainInfo: TollDomainDetails;
  navigation: INavigation;
  total: number;
  errorMessage: string;
  userSelection: IUserSelection;
  rule: Rule;
  datInstances: Array<any>;
  variants: Array<Variant>;
}

export interface IGeometryState {
  [view: string]: boolean;
}

export interface IGeometryStatePayload {
  stateKey: string;
  view: string;
  stateValue: boolean;
}

export interface IGeometryActions {
  label: string;
  enabled: boolean;
}

export interface GeometryState {
  periods: Periods;
}
